import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppLoadingService {
  private count = 0;
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private messageSubject = new BehaviorSubject<string>('');

  loading$ = this.loadingSubject.asObservable();
  message$ = this.messageSubject.asObservable();

  show(message = 'Laster inn...') {
    this.count++;
    this.messageSubject.next(message);
    if (this.count === 1) {
      this.loadingSubject.next(true);
    }
  }

  hide() {
    this.count = Math.max(0, this.count - 1);
    if (this.count === 0) {
      this.loadingSubject.next(false);
    }
  }

  reset() {
    this.count = 0;
    this.loadingSubject.next(false);
    this.messageSubject.next('');
  }
}

